<template>
      <div id="ub" class="block-shadow">
        <div class="row">
          <div class="col-12">
            <h3 class="table-title">{{'report.data_UB' | trans }}</h3>
            <p class="table-subtitle">{{'behavior.average_behavior' | trans }}</p>

            <div class="row mt-3">
              <div class="col-12" v-if="measurements">
                <line-chart v-bind:datasets="lineChartDataset"
                            v-bind:show-legend="false"
                            :animation-duration=0
                            :height=null
                            :width=null
                            v-bind:y-axes-begin-at-zero="true"/>

              </div>

            </div>
            <div class="row mt-5">
              <div class="col-lg-4 col-md-6 col-sm-12" v-if="antecedentTypes">
                <p class="table-subtitle">{{'behavior.ancedent' | trans }}</p>

                <bar-chart :bardatasets="barChartAncedentDataset"
                           v-bind:show-legend="false" :height="260"/>
                <div v-for="label in barChartAncedentDataset" class="legend-item"><span
                    :style="{background:label.backgroundColor}"></span>{{label.label}}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12" v-if="behaviorTypes">
                <p class="table-subtitle">{{'behavior.unwanted_behavior' | trans }}</p>

                <bar-chart :bardatasets="barChartBehaviorDataset"
                           v-bind:show-legend="false" :height="260"/>
                <div v-for="label in barChartBehaviorDataset" class="legend-item"><span
                    :style="{background:label.backgroundColor}"></span>{{label.label}}
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12" v-if="effectsTypes">
                <p class="table-subtitle">{{'behavior.aftermath' | trans }}</p>

                <bar-chart :bardatasets="barChartEffectsDataset"
                           v-bind:show-legend="false" :height="260"/>
                <div v-for="label in barChartEffectsDataset" class="legend-item"><span
                    :style="{background:label.backgroundColor}"></span>{{label.label}}
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

</template>

<script>
  import apiUndesirableBehavior from '../../undesirableBehavior/api/undesirableBehavior';
  import {pagination} from '../../../common/mixins/pagination';
  import {mapState, mapGetters, mapActions} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import cloneDeep from 'lodash/cloneDeep';
  import Constants from '../../undesirableBehavior/Constants';
  import moment from 'moment';
  import lang from '../../../lang/translator';
  import forEach from 'lodash/forEach';
  import orderBy from 'lodash/orderBy';
  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';
  import {LineChart, LineChartDataset} from '../../../common/chart';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
      'changeData': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientTimezone': {
        type: [String],
        default() {
          return null;
        },
      },
      'rangeDateStart': {
        type: [Date],
        default() {
          return new Date();
        },
      },
      'rangeDateEnd': {
        type: [Date],
        default() {
          return new Date();
        },
      },
    },
    data() {
      return {
        activeBehaviorId: null,
        isModalVisible: false,
        isEditModalVisible: false,
        measurements: null,
        antecedentTypes: null,
        behaviorTypes: null,
        effectsTypes: null,
        antecedentLegend: null,
        behaviorLegend: null,
        effectsLegend: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
      };
    },
    components: {
      LineChart,
      Loader,
      BarChart,
    },

    computed: {
      ...mapState('behavior', [
        'behaviors',
        'isLoaded',
      ]),
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).unix() + (Math.abs(this.rangeDateStart.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).unix() + (Math.abs(this.rangeDateEnd.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },
      lineChartDataset() {
        return [this.fetchLineDatasetForChart()];
      },
      barChartAncedentDataset() {
        return this.fetchBarDatasetForChart(this.antecedentTypes,
            lang.get('behavior.ancedent'));
      },
      barChartBehaviorDataset() {
        return this.fetchBarDatasetForChart(this.behaviorTypes,
            lang.get('behavior.unwanted_behavior'));
      },
      barChartEffectsDataset() {
        return this.fetchBarDatasetForChart(this.effectsTypes,
            lang.get('behavior.aftermath'));
      },
    },

    created() {
      if (this.clientTimezone) {
        this.setDate();
      }
    },

    methods: {
      ...mapActions('behavior', [
        'setBehaviors',
        'setCurrentPage',
      ]),

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY')
      },

      fetchLineDatasetForChart() {
        let data = [], i = 0;
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: this.toLocaleDate(item.dateRange.end),
                y: item.perHourCount,
              },
          );
        });

        return new LineChartDataset({
          data,
        });

      },

      getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        if (color == '#255255') return '#333333';
        return color;
      },

      fetchBarDatasetForChart(listTypes, name) {
        let data = [], i = 0, label = name, backgroundColor, datasets = [],
            legends = [];

        let types = orderBy(listTypes, 'count', 'desc');

        forEach(types, (item) => {
          data = [
            {
              x: ++i,
              y: item.count,
            },
          ];
          label = item.title;
          backgroundColor = this.getRandomColor();
          legends.push({
            label: label,
            background: backgroundColor,
          });

          datasets.push(new BarChartDataset({
            data, label, labels: legends, backgroundColor, borderColor: backgroundColor,
          }));

        });

        return datasets;
      },

      setDate() {
       this.fetchMeasurement();
      },

      openDescription(id) {
        if (this.activeBehaviorId !== id) {
          this.activeBehaviorId = id;
        }
        else {
          this.activeBehaviorId = null;
        }
      },


      getDateTimestamp(date) {
        return moment(date).unix() +
            (Math.abs(date.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },


      fetchMeasurement: async function() {
        try {
          let response = await apiUndesirableBehavior.getCountBehavior(
              this.clientId,
              this.rangeDateStartTimestamp,
              this.rangeDateEndTimestamp,
          );
          this.measurements = response.data.data;

          let responseTypes = await apiUndesirableBehavior.getCountTypes(
              this.clientId,
              this.rangeDateStartTimestamp,
              this.rangeDateEndTimestamp,
          );
          this.antecedentTypes = responseTypes.data.data.antecedent;
          this.behaviorTypes = responseTypes.data.data.behavior;
          this.effectsTypes = responseTypes.data.data.effects;

        } catch (error) {
          console.dir(error);
        }
      },

    },


    watch: {
      rangeDateStart(oldValue, newValue) {
        let rangeDays = Constants.MILLISECONDS * Constants.SECONDS *
            Constants.MINUTES * Constants.HOURS * Constants.COUNT_DAY;
        if (!oldValue) {
          this.rangeDateStart = newValue;
        }
        let myDate = cloneDeep(this.rangeDateStart);
        let newDate = new Date(myDate.getTime() + rangeDays);

        if (newDate.getTime() / Constants.MILLISECONDS >
            moment.tz(new Date(), this.clientTimezone).
                utcOffset(0, true).
                unix()) {
          this.rangeDateEnd = moment().
              tz(this.clientTimezone).
              add(-(moment().utcOffset()), 'm')._d;
        }
        else {
          this.rangeDateEnd = newDate;
        }
      },
      changeData(){
        this.setDate()
      },
      clientTimezone() {
        if (this.clientTimezone) {
          this.setDate();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/reports/components/DataUB.vue